import React, { createContext, useContext, useState } from "react";

const RegionContext = createContext(null);

export function RegionProvider({ children }) {
  const [region, setRegion] = useState("global"); // global | sea | indonesia
  return (
    <RegionContext.Provider value={{ region, setRegion }}>
      {children}
    </RegionContext.Provider>
  );
}

export const useRegion = () => useContext(RegionContext);
